import axios from "@/libs/api.request";
// 获取列表
export const getBranchList = data => {
  return axios.request({
    url: "/finance/branch/bill/list",
    method: "post",
    data
  });
};
// 获取详情
export const getDetails = params => {
  return axios.request({
    url: `/finance/branch/bill/read/${params.id}`,
    method: "post",
    params
  });
};

// 删除数据
export const delBill = id => {
  return axios.request({
    url: `/finance/branch/bill/del/${id}`,
    method: "delete"
  });
};
// 更新数据
export const updateBill = data => {
  return axios.request({
    url: `/finance/branch/bill/update//${data.id}`,
    method: "post",
    data
  });
};

// 确认账单
export const confirmBill = id => {
  return axios.request({
    url: `/finance/branch/bill/confirm/${id}`,
    method: "post"
  });
};

// 核销账单
export const auditBill = data => {
  return axios.request({
    url: `/finance/branch/bill/audit/${data.id}`,
    method: "post",
    data
  });
};

// 重新计算
export const resetAmount = id => {
  return axios.request({
    url: `/finance/branch/bill/resetAmount/${id}`,
    method: "post"
  });
};
// 导出明细
export const exportDetails = id => {
  return axios.request({
    url: `/finance/branch/bill/exportDetail/${id}`,
    method: "post"
  });
};

// 明细挂起
export const hangDetails = data => {
  return axios.request({
    url: `/finance/branch/bill/removeOut/${data.id}`,
    method: "post",
    data
  });
};

// 删除明细
export const deleteDetails = data => {
  return axios.request({
    url: `/finance/branch/bill/deleteOut/${data.id}`,
    method: "post",
    data
  });
};
// 追加订单
export const appendCnbNo = data => {
  return axios.request({
    url: `/finance/branch/bill/append/${data.id}`,
    method: "post",
    data
  });
};
